import script from "./device-operater.vue?vue&type=script&setup=true&lang=js"
export * from "./device-operater.vue?vue&type=script&setup=true&lang=js"

import "./device-operater.vue?vue&type=style&index=0&id=58e81d62&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e81d62"]])

export default __exports__